"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/layout/index.vue"));
var _reportSubMenu = require("./subMenus/report-sub-menu");
var _itemWiseReportSubMenu = require("./subMenus/item-wise-report-sub-menu");
var _newItemWiseReportSubMenu = require("./subMenus/new-item-wise-report-sub-menu");
var _dealerWiseOsOdReport = require("./subMenus/dealer-wise-os-od-report");
var _paymentReportSubMenu = require("./subMenus/payment-report-sub-menu");
var _rangeWiseReportSubMenu = require("./subMenus/range-wise-report-sub-menu");
var _stockValueReportSubMenu = require("./subMenus/stock-value-report-sub-menu");
var _itemWiseSalesLedgerReportSubMenu = require("./subMenus/item-wise-sales-ledger-report-sub-menu");
var _salesReportWithNotesSubMenu = require("./subMenus/sales-report-with-notes-sub-menu");
// import { averageReportSubMenu } from './subMenus/avg-report-sub-menu'

const reportRouter = {
  path: '/report',
  component: _index.default,
  redirect: 'noredirect',
  name: 'Reports',
  meta: {
    roles: ['Super Admin', 'Admin',
    // "Account Manager",
    'Read Only', 'Regional Manager', 'Zonal Manager', 'Agent', 'Branch Manager', 'Unit Manager', 'Payment Manager', 'Invoice Manager'],
    title: 'report.title',
    icon: 'international'
  },
  children: [..._reportSubMenu.salesReportSubMenu, ..._itemWiseReportSubMenu.itemWiseReportSubMenu, ..._newItemWiseReportSubMenu.newItemWiseReportSubMenu, ..._dealerWiseOsOdReport.dealerWiseOsOdReportSubMenu, ..._paymentReportSubMenu.paymentReportSubMenu,
  // ...averageReportSubMenu,
  ..._rangeWiseReportSubMenu.rangeWiseReportSubMenu, ..._stockValueReportSubMenu.stockValueReportSubMenu, ..._itemWiseSalesLedgerReportSubMenu.itemWiseSalesLedgerReportSubMenu, ..._salesReportWithNotesSubMenu.salesReportWithNotesSubMenu]
};
var _default = exports.default = reportRouter; // ...dealerWiseCashDiscountSubMenu,